<p-dialog header="Edit your comment" [(visible)]="bookingService.activeInternalBookingCommentEdit" [modal]="true">
  <app-edit-internal-booking-comment *ngIf="bookingService.internalCommentForm"></app-edit-internal-booking-comment>
</p-dialog>
<div class="accommodation-form-container" [formGroup]="bookingAccommodationService.accommodationForm">
  <div class="accommodation-top1">
    <div class="title-container">
      <h3 class="title">
        Dates
      </h3>
    </div>
    <div class="accommodation-date-form">
      <div class="list-item">
        <p-checkbox [binary]="true" formControlName="canEditAccommodationDate"></p-checkbox>
        <span class="different-dates-span">Different dates</span>
      </div>
      <div class="list-item">
        <div class="calendar-container">
          <p>
            Start date
          </p>
          <p-calendar formControlName="accommodationStartDate" [monthNavigator]="true"
            [yearRange]="bookingService.yearRange" [yearNavigator]="true" formControlName="accommodationStartDate"
            dateFormat="dd/mm/yy" [showIcon]="true"
            [disabled]="!bookingAccommodationService.accommodationForm.get('canEditAccommodationDate')!.value">
          </p-calendar>
        </div>
      </div>
      <div class="list-item">
        <div class="calendar-container">
          <p>
            End date
          </p>
          <p-calendar formControlName="accommodationEndDate" [monthNavigator]="true"
            [yearRange]="bookingService.yearRange" [yearNavigator]="true" formControlName="accommodationEndDate"
            dateFormat="dd/mm/yy" [showIcon]="true"
            [disabled]="!bookingAccommodationService.accommodationForm.get('canEditAccommodationDate')!.value">
          </p-calendar>
        </div>
      </div>
    </div>
  </div>
  <div class="accommodation-top2">
    <div class="title-container">
      <h3 class="title">
        Name
      </h3>
    </div>
    <div class="accommodation-name-form">
      <div class="list-item"
        *ngIf="bookingAccommodationService.accommodationForm.get('accommodationType')!.value.id == 2">
        <p>
          Family name
        </p>
        <input pInputText formControlName="hostLastName" class="person-name-input">
      </div>
      <div class="list-item"
        *ngIf="bookingAccommodationService.accommodationForm.get('accommodationType')!.value.id == 2">
        <p>
          First name
        </p>
        <input pInputText formControlName="hostFirstName" class="person-name-input">
      </div>
      <div class="list-item"
        *ngIf="bookingAccommodationService.accommodationForm.get('accommodationType')!.value.id != 2">
        <p>
          Name
        </p>
        <input pInputText formControlName="accommodationName" class="person-name-input">
      </div>
    </div>
  </div>
  <div class="accommodation-top3">
    <div class="title-container">
      <h3 class="title">
        Address
      </h3>
    </div>
    <div class="accommodation-address-form">
      <div class="list-item">
        <p>
          Address
        </p>
        <input pInputText formControlName="address" class="address-input">
      </div>
      <div class="list-item">
        <p>
          Post code
        </p>
        <input pInputText formControlName="accommodationPostCode">
      </div>
      <div class="list-item">
        <p>
          City
        </p>
        <input pInputText formControlName="city">
      </div>
      <div class="list-item">
        <p>
          Country
        </p>
        <p-dropdown formControlName="hostCountry" placeholder="-Select Country-" [options]="bookingService.countryList"
          optionLabel="name" [filter]="true" filterBy="name" [showClear]="true"></p-dropdown>
      </div>
    </div>
  </div>
  <div class="accommodation-top4">
    <div class="title-container">
      <h3 class="title">
        Extra info
      </h3>
    </div>
    <div class="accommodation-extra-info-form">
      <div class="list-item">
        <p>
          Travel time to school
        </p>
        <input pInputText formControlName="travelTimeToSchool">
      </div>
      <div class="list-item">
        <p>
          Other international students
        </p>
        <input pInputText formControlName="otherInternationalStudent">
      </div>
    </div>
  </div>
  <div class="accommodation-middle1">
    <div class="title-container">
      <h3 class="title">
        Preferences
      </h3>
    </div>
    <div class="accommodation-preferences-form">
      <div class="list-item">
        <p>
          Accommodation type
        </p>
        <p-dropdown formControlName="accommodationType" [options]="bookingAccommodationService.accommodationTypes"
          optionLabel="name">
        </p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Room Type
        </p>
        <p-dropdown formControlName="roomType" [options]="bookingAccommodationService.roomTypes" optionLabel="name">
        </p-dropdown>
      </div>
      <div class="list-item">
        <p>
          Pension
        </p>
        <p-dropdown formControlName="boardType" [options]="bookingAccommodationService.boardTypes" optionLabel="name">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="accommodation-middle2">
    <div class="title-container">
      <h3 class="title">
        Contact information
      </h3>
    </div>
    <div class="accommodation-contact-form">
      <div class="list-item">
        <p>
          Phone
        </p>
        <input pInputText formControlName="phoneNumber">
      </div>
      <div class="list-item">
        <p>
          Email
        </p>
        <input pInputText formControlName="email" class="email-input">
      </div>
      <div class="list-item">
        <p>
          Language
        </p>
        <p-dropdown formControlName="accommodationLanguage" placeholder="-Select Language-"
          [options]="bookingService.languages" optionLabel="name" [showClear]="true"></p-dropdown>
      </div>
    </div>
  </div>
  <div class="accommodation-bottom1">
    <div class="title-container">
      <h3 class="title">
        Internal comments
      </h3>
    </div>
    <div class="accommodation-internal-comments-container">
      <div class="new-internal-comment-container">
        <textarea placeholder="New comment to add" formControlName="internalComment"
          class="new-internal-comment"></textarea>
        <p-button label="Post" (onClick)="postInternalComment()"></p-button>
      </div>
      <div class="internal-comments-container">
        <div *ngFor="let comment of bookingService.booking.internalCommentList" class="internal-comment-box">
          <div class="internal-comment-body">
            {{comment.body}}
          </div>
          <div class="internal-comment-options-container">
            <span class="internal-comment-detail">
              {{comment.createdBy!.name}} at {{comment.created | date:"dd/MM/yyyy HH:mm"}}
              <span *ngIf="comment.isModified">
                (edited)
              </span>
            </span>
            <span *ngIf="comment.createdBy!.name == userService.userName">
              <a (click)="bookingService.activateInternalCommentEditDialog(comment)">
                Edit
              </a>
              -
              <a (click)="deleteComment(comment)">
                Delete
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="accommodation-bottom2">
    <div class="title-container">
      <h3 class="title">
        Accommodation remarks
      </h3>
    </div>
    <div class="accommodation-comment-container">
      <textarea formControlName="accommodationComment" class="comment-to-school"></textarea>
    </div>
  </div>
</div>